import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../lib/utils';

export interface TaskySelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean;
}

export const TaskySelect = React.forwardRef<HTMLSelectElement, TaskySelectProps>(
  ({ className, hasError, disabled, children, ...rest }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        {...rest}
        disabled={disabled}
        className={cn(
          'w-full h-10 pl-3 pr-9 text-base text-dark appearance-none',
          'bg-white border border-warm-border rounded-tasky-sm transition-colors',
          'focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary',
          hasError && 'border-destructive focus:ring-destructive/30 focus:border-destructive',
          disabled && 'bg-gray-100 text-gray-500 cursor-not-allowed',
          className,
        )}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
      />
    </div>
  ),
);
TaskySelect.displayName = 'TaskySelect';
